import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const StudentCourseContentView = ({
  CourseContentData,
  courseUnit,
  setActiveUnitData,
  activeUnitData,
}) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(1);
  const [searchParams] = useSearchParams();

  //   const handleItemClick = useCallback((index) => {
  //   setCurrentItemIndex(index);
  // }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = async () => {
    await new Promise((resolve) => setTimeout(resolve, 500));

    const curriculumId = searchParams.get("curriculum-id");

    if (curriculumId) {
      const curriculumIndex = courseUnit?.curricula.filter(
        (unit) =>
          (unit?.videos?.[0]?.id ||
            unit?.articles?.[0]?.id ||
            unit?.assignments?.[0]?.id) === Number(curriculumId)
      );

      if (curriculumIndex?.length) {
        setActiveUnitData(curriculumIndex[0]);
        setCurrentItemIndex(curriculumIndex[0].id);
      }
    }
  };
  useEffect(() => {
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sort the curricula array by created_at in ascending order
  const sortedCurricula = courseUnit?.curricula
    ? [...courseUnit.curricula].sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      )
    : [];

  return (
    <>
      {sortedCurricula?.map((chapter, index) => {
        let article = chapter?.articles[0];
        let video = chapter?.videos[0];
        let assignment = chapter?.assignments[0];

        return (
          <div
            key={chapter.id}
            className={`chapter-card py-12 px-20 mb-11 d-flex align-items-center cursor-pointer ${
              chapter === activeUnitData ? "inprogress" : ""
            }`}
            onClick={() => {
              setActiveUnitData(chapter);
              setCurrentItemIndex(chapter.id);
            }}
          >
            <div className="chapter-icon d-flex justify-content-center align-items-center me-7 ah-text-sm flex-shrink-0">
              {chapter.content_type === "video" ? (
                <svg
                  width="11"
                  height="9"
                  viewBox="0 0 11 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.55142 6.32658L7.61731 4.53941C7.65662 4.51692 7.68871 4.48541 7.71035 4.44805C7.73198 4.41069 7.74238 4.3688 7.74051 4.32661C7.74238 4.28442 7.73198 4.24253 7.71035 4.20517C7.68871 4.16781 7.65662 4.1363 7.61731 4.11381L4.55142 2.32664C4.51167 2.29835 4.46327 2.28194 4.41286 2.27965C4.36244 2.27735 4.31248 2.2893 4.26983 2.31384C4.22451 2.33497 4.18678 2.36743 4.16106 2.40739C4.13534 2.44736 4.1227 2.49316 4.12463 2.53943V6.11379C4.12463 6.21379 4.17303 6.28978 4.26983 6.33938C4.36575 6.38898 4.45991 6.38498 4.55142 6.32658ZM1.1001 8.32656C0.797383 8.32656 0.538665 8.22896 0.323068 8.03296C0.219021 7.94151 0.136685 7.83166 0.0811406 7.71017C0.0255957 7.58867 -0.00198123 7.45813 0.0001107 7.32657V1.32665C0.0001107 1.05145 0.10747 0.816254 0.323068 0.620257C0.538665 0.424259 0.798263 0.32666 1.1001 0.32666H9.90001C10.2027 0.32666 10.4614 0.424259 10.677 0.620257C10.8926 0.816254 11 1.05225 11 1.32665V7.32657C11 7.60177 10.8926 7.83697 10.677 8.03296C10.5764 8.12755 10.4556 8.2024 10.322 8.2529C10.1883 8.30339 10.0447 8.32846 9.90001 8.32656H1.1001ZM1.1001 7.32657H9.90001V1.32665H1.1001V7.32657Z"
                    fill="#F05203"
                  />
                </svg>
              ) : chapter.content_type === "assignment" ? (
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4748_3414)">
                    <path
                      d="M3.4375 8.75H1.25V1.25001H4.375V2.50001C4.375 2.66577 4.44085 2.82474 4.55806 2.94195C4.67527 3.05916 4.83424 3.12501 5 3.12501H6.25V4.6875C6.25 4.77039 6.28292 4.84987 6.34153 4.90848C6.40013 4.96708 6.47962 5 6.5625 5C6.64538 5 6.72487 4.96708 6.78347 4.90848C6.84208 4.84987 6.875 4.77039 6.875 4.6875V2.81251C6.87524 2.77138 6.86735 2.73061 6.8518 2.69253C6.83625 2.65446 6.81334 2.61983 6.78437 2.59063L4.90938 0.71563C4.88018 0.686667 4.84554 0.663753 4.80747 0.648202C4.7694 0.63265 4.72863 0.624767 4.6875 0.625005H1.25C1.08424 0.625005 0.925268 0.690853 0.808058 0.808063C0.690848 0.925274 0.625 1.08424 0.625 1.25001V8.75C0.625 8.91576 0.690848 9.07474 0.808058 9.19195C0.925268 9.30916 1.08424 9.375 1.25 9.375H3.4375C3.52038 9.375 3.59987 9.34208 3.65847 9.28348C3.71708 9.22487 3.75 9.14538 3.75 9.0625C3.75 8.97962 3.71708 8.90014 3.65847 8.84153C3.59987 8.78293 3.52038 8.75 3.4375 8.75ZM5 1.69063L5.80937 2.50001H5V1.69063Z"
                      fill="#F05203"
                    />
                    <path
                      d="M2.1875 4.375H3.75C3.83288 4.375 3.91237 4.34208 3.97097 4.28347C4.02958 4.22487 4.0625 4.14538 4.0625 4.0625C4.0625 3.97962 4.02958 3.90013 3.97097 3.84153C3.91237 3.78292 3.83288 3.75 3.75 3.75H2.1875C2.10462 3.75 2.02513 3.78292 1.96653 3.84153C1.90792 3.90013 1.875 3.97962 1.875 4.0625C1.875 4.14538 1.90792 4.22487 1.96653 4.28347C2.02513 4.34208 2.10462 4.375 2.1875 4.375ZM5.625 5.3125C5.625 5.22962 5.59208 5.15013 5.53347 5.09153C5.47487 5.03292 5.39538 5 5.3125 5H2.1875C2.10462 5 2.02513 5.03292 1.96653 5.09153C1.90792 5.15013 1.875 5.22962 1.875 5.3125C1.875 5.39538 1.90792 5.47487 1.96653 5.53347C2.02513 5.59208 2.10462 5.625 2.1875 5.625H5.3125C5.39538 5.625 5.47487 5.59208 5.53347 5.53347C5.59208 5.47487 5.625 5.39538 5.625 5.3125ZM2.1875 6.25C2.10462 6.25 2.02513 6.28292 1.96653 6.34153C1.90792 6.40013 1.875 6.47962 1.875 6.5625C1.875 6.64538 1.90792 6.72487 1.96653 6.78347C2.02513 6.84208 2.10462 6.875 2.1875 6.875H4.6875C4.77038 6.875 4.84987 6.84208 4.90847 6.78347C4.96708 6.72487 5 6.64538 5 6.5625C5 6.47962 4.96708 6.40013 4.90847 6.34153C4.84987 6.28292 4.77038 6.25 4.6875 6.25H2.1875ZM8.4375 4.375H8.38438C8.13582 4.37522 7.89752 4.47413 7.72187 4.65L4.84062 7.53125C4.76517 7.60949 4.71227 7.70666 4.6875 7.8125L4.375 8.9875C4.36177 9.03979 4.3623 9.09461 4.37654 9.14663C4.39078 9.19866 4.41824 9.24611 4.45625 9.28437C4.49601 9.32509 4.54612 9.35417 4.60119 9.36849C4.65626 9.38281 4.7142 9.38182 4.76875 9.36562L5.9375 9.0625C6.04805 9.0358 6.1488 8.97838 6.22813 8.89687L9.10938 6.01562C9.27878 5.84155 9.37401 5.60852 9.375 5.36563V5.3125C9.375 5.06386 9.27623 5.8254 9.10041 4.64959C8.9246 4.47377 8.68614 4.375 8.4375 4.375ZM6.40625 7.84062L5.90938 7.34375L7.65625 5.59687L8.15312 6.09375L6.40625 7.84062ZM5.78125 8.46562L5.11875 8.63125L5.28437 7.96875L5.47188 7.78125L5.96875 8.27812L5.78125 8.46562ZM8.75 5.36563C8.75024 5.40675 8.74235 5.44752 8.7268 5.4856C8.71125 5.52367 8.68834 5.5583 8.65937 5.5875L8.59375 5.65313L8.09688 5.15625L8.1625 5.09063C8.1917 5.06166 8.22633 5.03875 8.2644 5.0232C8.30248 5.00764 8.34325 4.99976 8.38438 5H8.4375C8.52038 5 8.59987 5.03292 8.65847 5.09153C8.71708 5.15013 8.75 5.22962 8.75 5.3125V5.36563Z"
                      fill="#F05203"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4748_3414">
                      <rect width="10" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  width="9"
                  height="12"
                  viewBox="0 0 9 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.93639 0.622925C3.38071 0.622925 2.93025 1.07339 2.93025 1.62906H1.92411C1.36843 1.62906 0.917969 2.07953 0.917969 2.6352V10.1813C0.917969 10.7369 1.36843 11.1874 1.92411 11.1874H7.96095C8.51664 11.1874 8.96709 10.7369 8.96709 10.1813V2.6352C8.96709 2.07953 8.51664 1.62906 7.96095 1.62906H6.95481C6.95481 1.07339 6.50436 0.622925 5.94867 0.622925H3.93639ZM6.2002 1.62906C6.2002 1.49015 6.08757 1.37753 5.94867 1.37753H3.93639C3.79747 1.37753 3.68485 1.49015 3.68485 1.62906V2.38367C3.68485 2.52259 3.79747 2.6352 3.93639 2.6352H5.94867C6.08757 2.6352 6.2002 2.52259 6.2002 2.38367V1.62906ZM6.95481 2.38367C6.95481 2.93935 6.50436 3.38981 5.94867 3.38981H3.93639C3.38071 3.38981 2.93025 2.93935 2.93025 2.38367H1.92411C1.78519 2.38367 1.67257 2.49629 1.67257 2.6352V10.1813C1.67257 10.3202 1.78519 10.4328 1.92411 10.4328H7.96095C8.09985 10.4328 8.21248 10.3202 8.21248 10.1813V2.6352C8.21248 2.49629 8.09985 2.38367 7.96095 2.38367H6.95481Z"
                    fill="#F05203"
                  />
                </svg>
              )}
            </div>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                <div className="text-base fw-semibold mb-0 pe-10">
                  {index + 1}.{" "}
                  {chapter.content_type === "video"
                    ? video?.title
                    : chapter?.content_type === "assignment"
                    ? assignment?.title
                    : article?.title}
                </div>
                <div className="text-sm fw-normal chapter-status">
                  {chapter.duration}
                </div>
              </div>
              {((chapter.content_type === "video" && video?.completed) ||
                (chapter?.content_type === "article" && article?.completed) ||
                (chapter?.content_type === "assignment" &&
                  assignment?.completed)) && (
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0"
                >
                  <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                  <path
                    d="M6.75 13.5767L9.75 16.5767L16.75 9.57666"
                    stroke="#82BD00"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
              {chapter.status === "Completed" && (
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                  <path
                    d="M6.75 13.5767L9.75 16.5767L16.75 9.57666"
                    stroke="#82BD00"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default StudentCourseContentView;
